module.exports = __webpack_public_path__ + "static/media/close-ico.644d4812.svg";